/**
 * @namespace Dialog
 * @aka SWRNEU.Dialog
 */
(function ($) {
  function createDialog(id, header, body, close) {
    const closeTemplate = COMMON.Utils.template('' +
      '<button id="{id}" type="button" class="btn btn-tertiary btn-tertiary-neutral btn-icon btn-small" data-dialog-close="true">' +
        SWRNEU.Util.svgIcon("close", "Dialogfenster schließen") +
      '</button>', {
      id: id
    });

    if('undefined' === typeof close || close === null) {
      close = closeTemplate;
    }

    return COMMON.Utils.template('' +
      '<dialog id="{id}" class="dialog" tabindex="-1" aria-labelledby="dialog-label">' +
      '  <div class="dialog-wrapper">' +
      '    <div class="dialog-header">' +
      '      <h2 id="dialog-label">{header}</h2>' +
      '      {close}' +
      '    </div>' +
      '    <div class="dialog-body">' +
      '      {body}' +
      '    </div>' +
      '  </div>' +
      '</dialog>', {
      id: id,
      header: header,
      close: close,
      body: body
    });
  }

  function addEventHandler($dialog, isInteractionBar = false, removeAfterClose = false) {
    $dialog.on('swr:dialog:close', function () {
      if(removeAfterClose) {
        closeDialog($dialog, true);
      } else {
        closeDialog($dialog);
      }
    });

    //Ein Button zum Öffnen des Dialogs wurde geklickt
    $('[data-dialog-target="#' + $dialog[0].id + '"][data-dialog-open="true"]').on('click', function () {
      $dialog.trigger('swr:dialog:open');
    });

    //Der Dialog soll geöffnet werden
    $dialog.on('swr:dialog:open', function () {
      openDialog($dialog, isInteractionBar);
    })
  }

  function openDialog($dialog, isInteractionBar) {
    $dialog[0].showModal();
    $dialog[0].style.setProperty("--_dialogHeight", $dialog[0].clientHeight + "px");
    bindClick($dialog, isInteractionBar);
    let dialogLabel = $dialog.find('#dialog-label')[0];

    if('undefined' === typeof dialogLabel && 'undefined' === typeof $dialog.attr('aria-label')) {
      $dialog.attr('aria-labelledby', 'dialog-label');
      dialogLabel = $dialog.find('.dialog-header h2');
      dialogLabel.attr('tabindex', '-1');
      dialogLabel.attr('id', 'dialog-label');
      dialogLabel = dialogLabel[0].innerText;
    }

    if('undefined' === typeof dialogLabel && 'undefined' !== typeof $dialog.attr('aria-label')) {
      dialogLabel = $dialog.attr('aria-label');
    }

    $dialog[0].focus();

    try {
      PIANO.UsabilityClick.usabilityClickEvent({
        'type': 'action',
        'click': 'Das Dialogfenster hat sich geöffnet',
        'click_chapter1': 'Dialogfenster',
        'click_chapter3': dialogLabel || ''
      });
    } catch (e) {
      console.warn(e);
    }
  }

  function closeDialog($dialog, remove = false) {
    $dialog[0].close();
    $dialog.off('click');

    try {
      PIANO.UsabilityClick.usabilityClickEvent({
        'type': 'action',
        'click': 'Das Dialogfenster wurde geschlossen',
        'click_chapter1': 'Dialogfenster',
        'click_chapter3': $dialog.find('#dialog-label').text()
      });
    } catch (e) {
      console.warn(e);
    }

    if(remove) {
      $dialog.off();
      $dialog.remove();
    }
  }

  function bindClick($dialog, isInteractionBar) {
    const $dialogWrapper = $dialog.find('[class$="-wrapper"]');

    $dialog.on('click', function (event) {
      var target = event.target;
      var $target = $(target);

      if (target.tagName !== 'BUTTON') {
        //Wenn der Klick zum Beispiel auf einem Bestandteil eines
        //Buttons lag, dann wird der Button ermittelt.
        var $closest = $target.closest('button');
        if ($closest.length !== 0) {
          target = $closest[0];
          $target = $(target);
        }
      }

      if (isInteractionBar) {
        if ($target.closest('.interaction-bar-share-mastodon').length !== 0) {
          //Klick lag innerhalb des Mastodon-Formulars
          return;
        }
      }

      if ($dialogWrapper.find($target).length === 0 && !$dialogWrapper.is($target)) {
        //Lag der Klick außerhalb des Wrappers, also auf dem Backdrop, wird das Dialogfenster geschlossen.
        $dialog.trigger('swr:dialog:close');
      } else {
        if ($target.attr('data-dialog-close') === "true") {
          $dialog.trigger('swr:dialog:close');
        } else {
          $dialog.trigger('swr:dialog:element-clicked', {element: $target});
        }
      }
    });
  }

  SWRNEU.Dialog = {
    createDialog: createDialog,
    addEventHandler: addEventHandler
  };
})(window.jQuery);
